import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { ConfigService } from 'src/services/config.service';
import { configModel } from 'src/models/config.model';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { Function } from 'src/Utilities/enum';

@Component({
  selector: 'app-admin-site-configuration',
  templateUrl: './admin-site-configuration.component.html',
  styleUrls: ['./admin-site-configuration.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class AdminSiteConfigurationComponent implements OnInit {
  configModel: configModel;
  hcontact: string = '';
  aboutus: string = '';
  imageSrc: string = '';
  isLoading: boolean = false;
  isUploading: boolean = false;
  uploadProgress: number = 0;
  selectedFileName: string = '';
  selectedFile: File = null;
  userMessage: string = '';

  @ViewChild('aboutUsTextarea') aboutUsTextarea: ElementRef;
  @ViewChild('contactUsTextarea') contactUsTextarea: ElementRef;
  @ViewChild('userMessageTextarea') userMessageTextarea: ElementRef;
  private readonly authStore = inject(AuthStore);


  constructor(
    private configService: ConfigService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit() {
    this.loadImage();

    this.reloadingConfig();
    
  }
  
  get gridEnabled(): boolean {
    return this.authStore.isVisible(Function.EditSiteConfiguration);
  }

  reloadingConfig() {
    this.configService.reloadConfig().subscribe(configModel => {
      Promise.resolve().then(() => {
        this.aboutus = configModel?.getConfigkeyname('About_Us') || '';
        this.hcontact = configModel?.getConfigkeyname('Header_Contact') || '';
        this.userMessage = configModel?.getConfigkeyname('Banner_Message') || '';
        this.cdr.detectChanges();
      });
    });
  }

  triggerFileInput(): void {
    let fileInput: HTMLElement = document.getElementById('fileInput') as HTMLElement;
    fileInput.click();
  }

  updateImageSrc(event: Event): void {
    let fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      let file = fileInput.files[0];
      this.selectedFileName = file.name;
      this.selectedFile = file;
      this.isUploading = true;
      this.uploadProgress = 0;

      // Simulate upload progress
      let interval = setInterval(() => {
        this.uploadProgress += 10;
        if (this.uploadProgress >= 100) {
          clearInterval(interval);
          this.isUploading = false;
        }
      }, 200);

      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  loadImage(): void {
    this.isLoading = true;
    this.configService.getCurrentImage().subscribe(response => {
      Promise.resolve().then(() => {
        const data = JSON.parse(response.imageUrl);
        this.imageSrc = data.imageUrl;
        this.isLoading = false;
        this.cdr.markForCheck();
      });
    });
  }

  saveAll() {
    // Save configuration data
    let configData = [
      { Key: 'About_Us', Value: this.aboutus },
      { Key: 'Header_Contact', Value: this.hcontact },
    ];

    if (this.userMessage) {
      configData.push({ Key: 'Banner_Message', Value: this.userMessage });
    } else {
      configData.push({ Key: 'Banner_Message', Value: '' });
    }

    this.configService.updateAboutUsConfig(configData).subscribe(res => {
      if (res === 1) {
        this.configService.reloadConfig().subscribe(configModel => {
          this.aboutus = configModel?.getConfigkeyname('About_Us') || '';
          this.hcontact = configModel?.getConfigkeyname('Header_Contact') || '';
          this.userMessage = configModel?.getConfigkeyname('Banner_Message') || '';
          this.cdr.detectChanges();
        });
      }
    });

    if (this.selectedFile) {
      let formData = new FormData();
      formData.append('image', this.selectedFile);

      this.configService.uploadImage(formData).subscribe(
        (event) => {
          if (event.status === 'completed') {
            this.imageSrc = event.message.imageUrl;
            this.selectedFileName = '';
            this.selectedFile = null;
            this.ngOnInit()
          }
        },
        (error) => {
          console.error('Upload failed', error);
          this.selectedFileName = '';
          this.selectedFile = null;
        }
      );
    }

    alert("Configurations saved successfully.");
    this.router.navigate([this.router.url]);
    this.reloadingConfig()
  }
}
